import React, { useEffect } from "react";
import "./ChargingFirstPageCustom.css";
import * as $ from "jquery";
import { useState, useRef } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  INIT_STATE_SELECTS,
  INDEX,
} from "../../../../constants/driveglobalfilterinitalstates";
import CustomSelect from "./CustomSelect";
import { BsFillSkipForwardBtnFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../../redux/userSlice";

export default function ChargingFirstPageFilters(props) {
  const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
  const [changedColumn, setChangedColumn] = useState("");
  const [columnfilters, setcolumnfilters] = useState([]);
  const [singleBtn, setsingleBtn] = useState(false);

  const [toHIdeShowRCA, setToHIdeShowRCA] = useState("d-none");
  const [toSendChasisRCA, setToSendChasisRCA] = useState(0);
  const [userCityDepo, setUserCityDepo] = useState({});

  const odoref = useRef();
  const loggedInUser = useSelector(selectLoggedInUser);

  useEffect(() => {
    if (props.gloablfilter.VIN_NUM.length === 1) {
      setToHIdeShowRCA("d-inline-block");
      setToSendChasisRCA(props.fromTableToFilter_vin);
    }
  }, [props]);

  const inputElement = useRef();
  const socref = useRef();

  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  };

  const updateFilter = (arr, index) => {
    let state_ind = INDEX[index];
    setFilterData((prestate) => {
      return { ...filterdata, [state_ind]: arr };
    });
    setChangedColumn(index);
    if (columnfilters.indexOf(index) == -1) {
      setcolumnfilters([...columnfilters, index]);
    }
  };

  const vinnumChanged = (e) => {
    let enterter_vin = e.target.value;
    if (enterter_vin != "") {
      let new_vin = enterter_vin.split(",");
      if (new_vin.length == 1) {
        setsingleBtn(true);
      }
      setChangedColumn("VIN_NUM");
      let VIN_NUM = "VIN_NUM";
      setFilterData((prestate) => {
        return { ...filterdata, VIN_NUM: new_vin };
      });
      if (columnfilters.indexOf("VIN_NUM") == -1) {
        setcolumnfilters([...columnfilters, "VIN_NUM"]);
      }
    }
  };

  const startDateChanged = (date) => {
    let sDate = "startDate";
    setChangedColumn("startDate");
    setFilterData((prestate) => {
      return { ...filterdata, [sDate]: date };
    });
    if (columnfilters.indexOf("START_DATE") == -1) {
      setcolumnfilters([...columnfilters, "START_DATE"]);
    }
  };

  const endDateChanged = (date) => {
    let eDate = "endDate";
    setChangedColumn("endDate");
    setFilterData((prestate) => {
      return { ...filterdata, [eDate]: date };
    });
    if (columnfilters.indexOf("END_DATE") == -1) {
      setcolumnfilters([...columnfilters, "END_DATE"]);
    }
  };

  const changeOdo = (e) => {
    setChangedColumn("ODOMETER_INDEX");
    setFilterData((prestate) => {
      return { ...filterdata, ODOMETER: parseInt(e.target.value) };
    });
    if (columnfilters.indexOf("ODOMETER_INDEX") == -1) {
      setcolumnfilters([...columnfilters, "ODOMETER_INDEX"]);
    }
  };

  const onsubmit = (e) => {
    e.preventDefault();
    props.onsubmit(filterdata);
    if (userCityDepo.depot.length === 0) {
      if (filterdata.VIN_NUM.length === 1) {
        setToHIdeShowRCA("d-inline-block");
        setToSendChasisRCA(filterdata.VIN_NUM[0]);
      }
      props.onsubmit(filterdata);
    } else {
      if (filterdata.DEPO.length === 0) {
      } else {
        // e.preventDefault();
        if (filterdata.VIN_NUM.length === 1) {
          setToHIdeShowRCA("d-inline-block");
          setToSendChasisRCA(filterdata.VIN_NUM[0]);
        }
        props.onsubmit(filterdata);
      }
    }
  };
  const onreset = (e) => {
    window.location.reload(true);
  };

  return (
    <div className="container-fluid chargingMainDiv">
      <div className="row">
        {loggedInUser.flagForHideShow === "ERC" ? (
          <div className="col-md-11 text-end mr-0 filter_bus_icon_f">
            <div
              className={`text-start mr-1 rca_btn_charging ${toHIdeShowRCA}`}
            >
              <Link to={`/dashboard/rca/${toSendChasisRCA}`}>
                <button
                  type="button"
                  className="btn text-white rca_btn_charging_ace"
                >
                  <i className="fa fa-cogs"></i>
                  <b>&nbsp;&nbsp;RCA</b>
                </button>
              </Link>
            </div>
          </div>
        ) : (
          <div className="col-md-11 text-end"></div>
        )}
        <div className="col-md-1">
          <div className="text-end">
            <button
              type="button"
              id="filterIcon"
              className="btn btn-outline-primary material-icons ev_filter_icon"
              onClick={filterHideShow}
            >
              filter_alt
            </button>
          </div>
        </div>
      </div>

      <div
        className="bg-light chargingFilterDiv p-2 mb-2"
        id="filterSearch"
        style={{ display: "none", zIndex: 1 }}
      >
        <form className="row g-3 mt-2 chargingFilterForm">
          <div className="row">
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Start Date
                </label>
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  minDate={moment(
                    new Date("2022-07-01T00:00:00.000Z")
                  ).toDate()}
                  maxDate={moment().subtract(1, "days").toDate()}
                  selected={filterdata.startDate}
                  onChange={startDateChanged}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput2"
                  className="form-label"
                >
                  End Date
                </label>
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  minDate={moment(
                    new Date("2022-07-01T00:00:00.000Z")
                  ).toDate()}
                  maxDate={moment().subtract(1, "days").toDate()}
                  selected={filterdata.endDate}
                  onChange={endDateChanged}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput2"
                  className="form-label"
                >
                  Vin No / Chassis No
                </label>
                <input
                  autoComplete="off"
                  defaultValue={filterdata.VIN_NUM.join(",")}
                  className="top-filter filter-col"
                  placeholder="Vin No / Chassis No"
                  id="vin_num"
                  ref={inputElement}
                  onBlur={vinnumChanged}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <CustomSelect
                  columnfilters={columnfilters}
                  changedColumn={changedColumn}
                  filterdata={filterdata}
                  lable="CITY"
                  IND="CITY_INDEX"
                  updateFilter={updateFilter}
                ></CustomSelect>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <CustomSelect
                  columnfilters={columnfilters}
                  changedColumn={changedColumn}
                  filterdata={filterdata}
                  lable="LOB"
                  IND="LOB_INDEX"
                  updateFilter={updateFilter}
                ></CustomSelect>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <CustomSelect
                  columnfilters={columnfilters}
                  changedColumn={changedColumn}
                  filterdata={filterdata}
                  lable="PPL"
                  IND="PPL_INDEX"
                  updateFilter={updateFilter}
                ></CustomSelect>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-3">
                <CustomSelect
                  columnfilters={columnfilters}
                  changedColumn={changedColumn}
                  filterdata={filterdata}
                  lable="PL"
                  IND="PL_INDEX"
                  updateFilter={updateFilter}
                ></CustomSelect>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="mb-0" style={{ marginTop: 0 }}>
                <label
                  htmlFor="exampleFormControlInput2"
                  className="select_col_title"
                >
                  Max Odometer
                </label>
                <select
                  className="form-select react-select__option_charg_ace"
                  aria-label="Default select example"
                  onChange={changeOdo}
                  ref={odoref}
                >
                  <option value={0}>All</option>
                  <option value={9999}>&lt;10K</option>
                  <option value={10000}>&gt;=10K</option>
                  <option value={20000}>&gt;=20K</option>
                  <option value={30000}>&gt;=30K</option>
                  <option value={40000}>&gt;=40K</option>
                  <option value={50000}>&gt;=50K</option>
                </select>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div style={{ marginTop: "1.2rem" }}>
                <label className="form-label" />
                <button
                  type="submit"
                  className="form-control btn btn-primary"
                  onClick={onsubmit}
                >
                  Search
                </button>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div style={{ marginTop: "1.2rem" }}>
                <label className="form-label" />
                <button
                  type="submit"
                  className="form-control btn btn-secondary"
                  onClick={onreset}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
